import { render } from "./NutonExperiment.vue?vue&type=template&id=503117e3&scoped=true"
import script from "./NutonExperiment.vue?vue&type=script&lang=js"
export * from "./NutonExperiment.vue?vue&type=script&lang=js"

import "./NutonExperiment.vue?vue&type=style&index=0&id=503117e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503117e3"]])

export default __exports__